import * as React from 'react';
import { Section } from './layout/Section';
import { Row, Col } from './bootstrap-components/BootstrapComponents';
import { Image } from '../uiComponents/layout/Image';

export interface ErrorWrapperProps {
    header: string;
    children: any;
}

export function ErrorWrapper(props: ErrorWrapperProps) {
    return (
        <Section className='error'>
            <Row>
                <Col md={6} mdOffset={3}>
                    <Row>
                        <Col md={4}>
                            <Image source='error.png' />
                        </Col>
                        <Col md={8}>
                            <h1>{props.header}</h1>
                            {props.children}                           
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Section>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/ErrorWrapper.tsx